<div class="container">
  <div class="content first-content">
    <div class="first-column">
      <h2 class="title title-primary">Login</h2>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="clienteLogin.email" placeholder="Email">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Senha</mat-label>
        <input matInput [(ngModel)]="clienteLogin.senha" placeholder="Senha">
      </mat-form-field>
      <p><a class="password" href="#">Esqueceu a senha?</a></p>
      <button id="signin" class="btn btn-primary" (click)="fazerlogin()">Entrar</button>
    </div>
    <div class="second-column">
      <h2 class="title title-second">Criar Conta</h2>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Nome</mat-label>
        <input matInput [(ngModel)]="cliente.nome" placeholder="nome">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>CPF</mat-label>
        <input matInput [(ngModel)]="cliente.cpf" placeholder="CPF">
        <td mat-cell *matCellDef="let cliente">{{cliente.cpf | cpf}}</td>

      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Telefone</mat-label>
        <input matInput [(ngModel)]="cliente.telefone" placeholder="Telefone">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Email</mat-label>
        <input matInput [(ngModel)]="cliente.email" placeholder="Email">
      </mat-form-field>
      <mat-form-field appearance="fill" class="mat-form-simples">
        <mat-label>Senha</mat-label>
        <input matInput [(ngModel)]="cliente.senha" placeholder="Senha">
      </mat-form-field>
      <button class="btn btn-second" (click)="inserirCliente()" *ngIf="operacaoCadastro">Cadastrar</button>

      <button class="btn btn-second" (click)="inserirCliente()" *ngIf="!operacaoCadastro">Editar</button>
    </div><!-- second column -->
  </div><!-- first content -->
</div>


